<template>
    <div class="sidebar lh" :class="{'sidebar-left-visible': showing}" @click="$emit('categ_close')">
        <div @click.stop="" @scroll.stop="" class="sidebar-left">        
            <ul id="menu-categories" class="menu-categories">
                <li> <h3> {{shop.name}} </h3> </li>
                <!--<li v-if="shops.length > 1"><a href="#" class="menu-category-link" @click="$emit('back')">&lt; Выбрать другой ресторан</a></li>-->
                <li>
                    <a v-for="cat in categlist" :key="cat" @click.prevent="$emit('scrollto', cat)" class="menu-category-link">{{ cat }}</a>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    props:['categlist', 'shops', 'shop', 'showing'],
    data() {
        return {
            
        }
    }        
}
</script>